"use strict";
// WEB-2490: we need to avoid importing multiple SVG with different sizes directly
// Til then, we keep the exiting props and introduce a another prop interface
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sizes = void 0;
var Sizes;
(function (Sizes) {
    Sizes[Sizes["Small"] = 12] = "Small";
    Sizes[Sizes["Medium"] = 16] = "Medium";
    Sizes[Sizes["Large"] = 24] = "Large";
    Sizes[Sizes["ExtraLarge"] = 32] = "ExtraLarge";
    Sizes[Sizes["DoubleExtraLarge"] = 48] = "DoubleExtraLarge";
})(Sizes = exports.Sizes || (exports.Sizes = {}));
//# sourceMappingURL=constants.js.map